@if ((displayedRanges$ | async)?.length > 0) {
    <div>
        <div class="display-flex medium-margin-bottom">
            <div class="range-size">
                {{ labels.minRangeLabel | translate }}
            </div>
            @if ((displayedValue$ | async) !== null) {
                <div class="cursor-size cursor-title">
                    {{ labels.valueLabel | translate }}
                </div>
            }
            @if ((displayedReferenceValue$ | async) !== null) {
                <div class="cursor-size cursor-title">
                    {{ labels.referenceLabel | translate }}
                </div>
            }
        </div>
        <div class="display-flex">
            <div class="ranges-container range-size">
                @for (range of displayedRanges$ | async; track range; let idx = $index) {
                    <div class="display-flex">
                        <div class="range" [ngStyle]="{ 'background-color': range.color }">
                            <span class="label">{{ range.label }}</span>
                            <div class="description small-margin-left">
                                @if (range.minValue > 0 && range.maxValue !== infinity) {
                                    <p>{{ range.minValue }} {{ 'STUFF.AT_NUMBER' | translate }} {{ range.maxValue }}</p>
                                }
                                @if (range.minValue === 0) {
                                    <p>≤ {{ range.maxValue }}</p>
                                }
                                @if (range.maxValue === infinity) {
                                    <p>> {{ range.minValue }}</p>
                                }
                            </div>
                        </div>
                        <div class="right-arrow" [ngStyle]="{ 'border-left-color': range.color }"></div>
                        <div [ngStyle]="{ width: 'calc(40px * ' + ((displayedRanges$ | async)?.length - idx - 1) + ')' }"></div>
                    </div>
                }
            </div>
            @if ((displayedValue$ | async) !== null) {
                <div class="cursor cursor-size">
                    <div class="value-cursor" [ngStyle]="{ 'margin-top': 'calc(42px * ' + (valuePosition$ | async) + ')' }">
                        <div class="left-arrow"></div>
                        <div class="label">{{ displayedValue$ | async | localnumber }}</div>
                    </div>
                </div>
            }
            @if ((displayedReferenceValue$ | async) !== null) {
                <div class="cursor cursor-size">
                    <div
                        class="reference-value-cursor"
                        [ngStyle]="{ 'margin-top': 'calc(42px * ' + (referenceValuePosition$ | async) + ')' }"
                    >
                        <div class="left-arrow"></div>
                        <div class="label">{{ displayedReferenceValue$ | async | localnumber }}</div>
                    </div>
                </div>
            }
        </div>
        <div class="display-flex medium-margin-top">
            <div class="range-size">
                {{ labels.maxRangeLabel | translate }}
            </div>
        </div>
    </div>
}
